<template>
  <div class="attributes" id="attribute-nav">
    <Regime v-if="$store.state.regime_nav_enabled"></Regime>

    <ToggleLabel
      v-if="!this.selectMultiple"
      :toggleable="toggleable"
      :closed="!open"
      title="Attributes"
      :selected="firstSelectedAttribute"
      :callback="toggleOpen"
    ></ToggleLabel>

    <ToggleLabel
      v-else
      :toggleable="toggleable"
      :closed="!open"
      title="Attributes"
      :selected="false"
      :callback="toggleOpen"
    ></ToggleLabel>

    <ul
      v-if="open === true && attribute.section === ''"
      v-bind:key="attribute.id"
      class="attributes__list"
      v-for="attribute in attributeHeaders"
    >
      <li class="attributes__list__item ">


        <SelectionMarker
          class="attributes__list__item__selectionmarker"
          color="gray-darkest"
          :selected="attributeIsSelected(attribute.id)"
          type="check"
        ></SelectionMarker>

        <AttributeLabel
          @toggleOpen="toggleSectionOpen(attribute.id)"
          @toggleSelect="toggleAttribute(attribute.id, attribute.id, attribute.selectable)"

          :open="(currentSection == attribute.id)"
          :selected="attributeIsSelected(attribute.id)"
          color="gray-darkest"

          :identifier="attribute.id"
          :title="attribute.name"
          :tooltip="attribute.description"
          :link="attribute.link"
        ></AttributeLabel>

        <transition name="slide">
          <ul v-if="(currentSection == attribute.id)" class="attributes__list__item__list">
            <li class="attributes__list__item__list__item"
              v-for="subattribute in attributeHeaders"
              v-if="subattribute.section === attribute.id"
            >
              <SelectionMarker
                class="selectionmarker"
                color="gray-darkest"
                :selected="attributeIsSelected(subattribute.id)"
                type="check"
              ></SelectionMarker>
              <Attribute
                :attr="subattribute"
                color="gray-darkest"
                :selected="attributeIsSelected(subattribute.id)"
                @selected="toggleAttribute(subattribute.id, attribute.id)"
                :tooltip="subattribute.description"
                :link="subattribute.link"
              ></Attribute>

              <ul class="subattributes__list__item__list" v-if="hasSubattributes(subattribute)">
                <li class="subattributes__list__item__list__item"
                  v-for="subsubattribute in attributeHeaders"
                  v-if="subsubattribute.section === subattribute.id"
                >
                  <SelectionMarker
                    class="selectionmarker selectionmarker--on-line"
                    color="gray-darkest"
                    :selected="attributeIsSelected(subsubattribute.id)"
                    type="check"
                  ></SelectionMarker>
                  <Attribute
                    :attr="subsubattribute"
                    color="gray-darkest"
                    :selected="attributeIsSelected(subsubattribute.id)"
                    @selected="toggleAttribute(subsubattribute.id, attribute.id)"
                    :tooltip="subsubattribute.description"
                    :link="subattribute.link"
                  ></Attribute>
                </li>
              </ul>

            </li>
          </ul>
        </transition>

      </li><!-- /.attributes__list__item -->
    </ul>

  </div><!-- /.page-navigation -->
</template>

<script>
import ToggleLabel from '../shared/ToggleLabel'
import AttributeLabel from './AttributeLabel'
import Attribute from './Attribute'
import SelectionMarker from './../shared/SelectionMarker'
import Regime from './Regime'

import _ from 'lodash'
import {EventBus} from '@/event-bus.js'

export default {
  name: 'attribute-nav',
  components: { Regime, ToggleLabel, Attribute, AttributeLabel, SelectionMarker },
  props: {
    useRandomColors: {
      type: Boolean,
      default: false
    },
    closed: {
      type: Boolean,
      default: false
    },
    toggleable: {
      type: Boolean,
      default: false
    },
    selectMultiple: {
      type: Boolean,
      default: true
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      currentSection: false,
      open: false
    }
  },
  computed: {
    attributeHeaders () {
      return this.$store.state.attributes.labels
    },
    firstSelectedAttribute () {
      let firstKey = this.$store.getters['attributes/firstSelected']
      if (!firstKey) return false

      let name = this.$store.getters['attributes/labelInfo'](firstKey, 'name')
      return name
    },
    selectedAttributes () {
      return this.$store.state.attributes.selected
    }
  },
  watch: {
    closed () {
      this.open = !this.closed
    },
    open () {
      this.$emit('toggleClosed', !this.open)
    },
    selectedAttributes () {
      // Make sure the section is open for the
      // last selected attribute
      let lastSelection = _.last(this.selectedAttributes)
      if (lastSelection) {
        let label = this.$store.getters['attributes/getLabelFromKey'](lastSelection)
        let section = label.section

        // Fix to make the subsubattributes link to
        // 1. level attribute
        if (section === 'SA_02_02' || section === 'SA_02_03') {
          section = 'A_02'
        }

        if (label && section && section !== this.currentSection) {
          this.toggleSectionOpen(label.section)
        }
      }
    }
  },
  mounted () {
    this.open = !this.closed

    // Upon mounting the navigation component we check if
    // someone should already have made a selection
    // in which case we open up the section
    if (this.attributeHeaders && Array.isArray(this.attributeHeaders)) {
      for (let attr of this.attributeHeaders) {
        if (attr.section === '') {
          let sectionIsOrContainsSelected = this.$store.getters['attributes/isOrContainsSelected'](attr.id)
          if (sectionIsOrContainsSelected) {
            this.currentSection = attr.id
          }
        }
      }
    }
  },

  methods: {
    /**
     * Checks if an attribute is selected
     * @param  {string} key The attribute ID
     * @return {boolean}
     */
    attributeIsSelected (key) {
      let i = this.$store.state.attributes.selected.indexOf(key)
      let num = this.$store.state.attributes.selected.length

      if (this.selectMultiple || num <= 1) {
        return i !== -1
      } else {
        return i === 0
      }
    },

    toggleSectionOpen (key) {
      let sectionIsOrContainsSelected = this.$store.getters['attributes/isOrContainsSelected'](key)

      if (this.currentSection === key) {
        this.currentSection = false
      } else {
        this.currentSection = key
      }

      if (!sectionIsOrContainsSelected) {
        this.$store.commit('attributes/resetAllSelected')
        this.$store.commit('resetSelectionColor')
      }
    },

    toggleAttribute (key, section, selectable = 'Yes') {
      this.$store.commit('resetSelectionColor')

      // Make sure no more than 7 attributes are selected
      if (this.selectedAttributes.length >= 7 && !this.attributeIsSelected(key)) {
        // TODO: put in $Strings
        EventBus.$emit('popup.open', 'Maximum attributes selected', 'The maximum amount of attributes are selected. Please unselect attributes to compare others.')

        return false
      }

      if (this.currentSection !== section) {
        this.toggleSectionOpen(section)
      }

      if (selectable === 'No') {
        EventBus.$emit('popup.open', this.$Strings('attributeNotAvailable'), this.$Strings('attributeNotAvailableContent'))
        return false
      }

      if (!this.selectMultiple) {
        this.$store.commit('attributes/resetAllSelected')
      }
      this.$store.dispatch('attributes/toggleSelect', key)

      if (this.closeOnSelect) { this.toggleOpen() }
    },
    toggleOpen () {
      this.open = !this.open
    },
    getAttributeColor (id) {
      if (!this.attributeIsSelected(id)) {
        return 'gray'
      }
      if (!this.useRandomColors) {
        let attr = this.$store.getters['attributes/getLabelFromKey'](id)
        if (attr && attr.color) {
          return attr.color
        }
      }
      return this.$store.getters.getSelectionColor(id)
    },
    hasSubattributes (attr) {
      for (let attr2 of this.attributeHeaders) {
        if (attr2.section === attr.id) {
          return true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~@/components/sass/shared/colors';
  @import '~@/components/sass/shared/fonts';

  .attributes{
    position: relative;
  }

  .attributes__title{
    border-bottom: 1px solid $gray-lighter;
    color: $gray-darker;
    font: 100 19px $fontfamily-serif;
    margin: 0 -20px;
    padding: 0 20px 20px;
  }
  .attributes__title--toggleable{
    cursor: pointer
  }

  .attributes__list{
    list-style-type: none;
    margin: 0;
    padding: 0 20px;
  }

  .attributes__list__item{
    border-bottom: 1px solid $gray-lighter;
    margin: 0 -20px;
    padding: 20px;
    position: relative;

    &:hover {
      background: lighten($gray-lighter, 5%);
    }
  }

  .attributes__list__item__selectionmarker{
    position: absolute !important;
    top: 30px;
    left: 6px;
  }

  .subattributes__list__item__list{
    list-style: none;
    margin: 20px 0 0 11px;
    padding: 0;
  }
  .subattributes__list__item__list__item{
    font-size: 13px;
    padding: 15px 0 0;
    position: relative;

    .attribute:not(.isActive){
      color: $gray !important;
    }
  }
  .subattributes__list__item__list__item:first-child{ padding-top: 0 }

  .filtersection{
    display: flex; -js-display: flex;
    font-size: 15px;
    font-weight: 500;
  }

  .filtersection__title{
    flex: 1 1 auto;
  }
  .filtersection__icon{
    align-items: center;
    display: flex; -js-display: flex;
    flex: 1 1 auto;
    justify-content: center;
    max-width: 40px;
  }

  .filtersection__title__help{
    display: inline-block;
    padding-left: 10px;
  }

  .filtersection__toggle{
    align-items: center;
    display: flex; -js-display: flex;
    font-size: 10px;
    flex: 0 0 45px;
    justify-content: flex-end;
    width: 45px;
  }

  .filtersection__icon__image{
    height: 25px;
    padding-right: 15px;
    width: 40px;
  }

  .attributes__list__item__list{
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  .attributes__list__item__list__item{
    padding: 15px 10px 15px 40px;
    position: relative;

    .selectionmarker{
      position: absolute;
      left: 20px;
      top: 20px;
    }

    &:first-child{
      padding-top: 2em;

      .selectionmarker{
        top: 33px;
      }
    }
  }

  .subattributes__list__item__list__item {
    .selectionmarker {
      left: -20px;
      top: 20px;
    }

    &:first-child {
      .selectionmarker {
        top: 5px;
      }
    }
  }

  .selectionmarker{
    position: relative;

  }

</style>



// WEBPACK FOOTER //
// src/components/shared/navigation/AttributesNavigation/Nav.vue